// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5aa75018","634":"a770c5c0","886":"7a9908cc"}[chunkId] + ".chunk.js";
};